import { AirlineOrderGroup } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IAirlineOrderGroupList } from "./list.gen.d";
import { Pagination } from "../../base_classes/pagination";
import { Query } from "../../base_classes/query";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class AirlineOrderGroupList
  extends DtoList
  implements IAirlineOrderGroupList
{
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/airline_order_group";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: AirlineOrderGroup[] = [];
  queriedList: AirlineOrderGroup[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): AirlineOrderGroup {
    return new AirlineOrderGroup([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>,
  ): Promise<AirlineOrderGroup[]> {
    return (await super.getAll(pathVars)) as AirlineOrderGroup[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination,
  ): Promise<{
    items: AirlineOrderGroup[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: AirlineOrderGroup[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination,
  ): Promise<{
    items: AirlineOrderGroup[];
    pagination: Pagination;
  }> {
    return (await super.query(queries, pagination)) as {
      items: AirlineOrderGroup[];
      pagination: Pagination;
    };
  }

  override async search(
    query: string,
    pagination?: Pagination,
  ): Promise<{
    items: AirlineOrderGroup[];
    pagination: Pagination;
  }> {
    return (await super.search(query, pagination)) as {
      items: AirlineOrderGroup[];
      pagination: Pagination;
    };
  }
}
